<template lang="pug">
    v-container( fluid id="website-theme-preview" fill-height class=" tw-p-0 tw-m-0  tw-items-start tw-content-start tw-overflow-x-hidden" )
        kubiqa-website-themes-theme-a-components-shared-top-navigation(changeOnScroll="false" titleColor='tw-text-black' appBarBg='tw-bg-white tw-shadow-lg')
        div(class="d-flex flex-row flex-grow-1 tw-w-full tw-z-90 tw-pt-18")
            gallery(:images="images" class="tw-w-full tw-relative tw-z-10")
        div(class="d-flex flex-row tw-mx-auto tw-flex-wrap tw-min-h-full  tw-content-start tw--mt-12 tw-w-10/12 ")
            v-container( fluid  class="tw-pt-0" )
                v-row
                    v-col(cols="9" xl="10")
                        div
                            span(class="tw-text-3xl tw-font-bold") {{ this.$faker().lorem.sentence(3) }}
                        div(class="tw-pt-1")
                            span(class="tw-text-lg text-secondary ") {{ this.$faker().address.streetAddress(true) }}, {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
                    v-col(cols="3" xl="2" )
                        v-row( justify="end" )
                            v-col(cols="auto")
                                span( class="tw-text-2xl tw-font-bold") ${{ this.$faker().finance.amount(10000,100000, 0)}} 
                        v-row(justify="end" class="tw--mt-6 tw-py-0 tw-my-0")
                            v-col(cols="auto")
                                v-btn( outlined color="black" @click="method" )
                                    v-icon() mdi-share-variant
                                    span() SHARE
            v-container( fluid class="tw-pt-0" )
                v-row
                    // Right column
                    v-col(cols="8" xl="9")
                        // Description
                        v-row
                            v-col
                                div()
                                    span( class=" tw-text-xl tw-font-bold") Description
                                div( class="tw-pt-2")
                                    span() {{ this.$faker().lorem.paragraphs(3) }}  
                        //Details
                        v-row(class="tw-pt-4")
                            v-col
                                v-row
                                    v-col
                                        span( class="tw-text-xl tw-font-bold") Details
                                v-row
                                    v-col
                                        span() 1 bedroom
                                    v-col
                                        span() 2 bathroom
                                    v-col
                                        span() 220 m2
                        // Floor Plans
                        v-row(class="tw-pt-4")
                            v-col
                                div()
                                    span( class=" tw-text-xl tw-font-bold") Floor Plans
                                div(class="tw-pt-2")
                                    v-img( src="https://via.placeholder.com/500x300" )
                                        
                        // Map
                        v-row(class="tw-pt-4")
                            v-col
                                div()
                                    span(class="tw-text-xl tw-font-bold") Map
                                div(class=" tw-pt-2")
                                    kubiqa-misc-map

                        //Similar properties
                        v-row(class="tw-pt-2" )
                            v-col
                                div()
                                    span(class=" tw-text-xl tw-font-bold") More listings
                                div(class="d-flex flex-row flex-wrap tw-mx-auto")
                                    div(v-for="item in 2" :key="item.id" class=" tw-w-1/2 tw-mx-0 tw-px-0 ")
                                        kubiqa-website-themes-theme-a-components-shared-listing-card()

                    // Left column
                    v-col(cols="4" xl="3")
                        v-container( class="tw-border tw-border-gray-lighten-2 tw-overflow-hidden tw-rounded"  )
                            v-row(class="tw-bg-black")
                                v-col
                                    span(class="tw-text-white tw-font-extrabold tw-text-lg") Contact
                            v-row
                                v-col
                                    v-text-field(label="Name" hide-details )
                                v-col
                                    v-text-field(label="Last Name" hide-details)
                            v-row
                                v-col
                                    v-text-field(label="Phone"  hide-details)
                            v-row
                                v-col
                                    v-text-field(label="Email"  hide-details)
                            v-row
                                v-col
                                    v-textarea(label="Message"  hide-details)
                            v-row(class="tw-pt-2")
                                v-col
                                    v-btn( outlined block color="black" )
                                        span() SEND
                    
        kubiqa-website-themes-theme-a-components-shared-footer
</template>
<script>
export default {
	data() {
		return {
			images: [],
		}
	},
	created() {
		for (let index = 0; index < 10; index++) {
			var image = {}

			image.description = this.$faker().lorem.sentence()
			image.href = this.sampleWebsiteImage('listing', 1200, 600, index)
			this.images.push(image)
		}
	},
}
</script>
<style>
.blueimp-gallery-display {
	position: absolute !important;
}
.more-btn {
	background: #ffffff !important;
	border-radius: 5px;
	color: #000000 !important;
	text-transform: uppercase !important;
	font-size: 14px !important;
	padding: 12px !important;
}
.img-right,
.img-left {
	border: solid 1px #ffffff !important;
}
</style>
